import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { Text } from '../atom/Text';
import { Flex } from '../atom/Layout';

import useEventVoucher from '../../../Hooks/useEventVoucher';
import { SizeToRem } from '../../../lib/style/ThemeStyle';
import { ReactComponent as DownLoadSvg } from '../../../lib/image/icons/download.svg';
import useEvent from '../../../Hooks/useEvent';

const Coupon = ({
  couponInfo: { title, discount, code, startDate, endDate },
}) => {
  const { onSetCouponButton, active } = useEventVoucher();
  const { isEventItemOn } = useEvent();
  const { isHomeBannerOn: isCouponOn } = isEventItemOn({ startDate, endDate });

  return (
    isCouponOn && (
      <CouponContainer
        active={active}
        onClick={() => active && onSetCouponButton({ code })}
      >
        <Flex
          column
          padding={`${SizeToRem(3)} ${SizeToRem(11)} ${SizeToRem(2)}`}
        >
          {active ? (
            <>
              <Text size={9} color="orangePink">
                {title ? title : LANG.discountCoupon}
              </Text>
              <Text size={12} color="orangePink">
                {discount}
              </Text>
            </>
          ) : (
            <Text size={12} color="pinkishGrey">
              {LANG.complete}
            </Text>
          )}
        </Flex>
        <IconContainer active={active}>
          <DownLoadSvg />
        </IconContainer>
      </CouponContainer>
    )
  );
};

Coupon.propTypes = {
  couponInfo: PropTypes.object.isRequired,
};

export default React.memo(Coupon);

const LANG = {
  discountCoupon: '할인쿠폰',
  complete: '받기완료',
};

const CouponContainer = styled(Flex)`
  height: 2rem;
  border-radius: 3px;
  border: solid 1px
    ${(props) =>
      props.active
        ? props.theme.color.orangePink
        : props.theme.color.pinkishGrey};
  cursor: ${(props) => (props.active ? 'pointer' : 'not-allowed')};
`;

const IconContainer = styled(CouponContainer)`
  padding: 0.375rem;
  background: ${(props) =>
    props.active
      ? props.theme.color.orangePink
      : props.theme.color.pinkishGrey};

  svg {
    width: 0.75rem;
    height: auto;
  }
`;
